/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DifficultyEnum = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type createMutationVariables = {|
  name: string,
  category?: ?string,
  difficulty?: ?DifficultyEnum,
  serves?: ?string,
  hotKeep?: ?boolean,
  description?: ?string,
|};
export type createMutationResponse = {|
  +recipeCreate: ?{|
    +recipe: ?{|
      +id: string,
      +name: string,
      +picture: ?string,
    |}
  |}
|};
export type createMutation = {|
  variables: createMutationVariables,
  response: createMutationResponse,
|};
*/


/*
mutation createMutation(
  $name: String!
  $category: ID
  $difficulty: DifficultyEnum
  $serves: String
  $hotKeep: Boolean
  $description: String
) {
  recipeCreate(input: {name: $name, category: $category, difficulty: $difficulty, serves: $serves, hotKeep: $hotKeep, description: $description}) {
    recipe {
      id
      name
      picture
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "difficulty",
    "type": "DifficultyEnum"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serves",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hotKeep",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "category",
            "variableName": "category"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "difficulty",
            "variableName": "difficulty"
          },
          {
            "kind": "Variable",
            "name": "hotKeep",
            "variableName": "hotKeep"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "serves",
            "variableName": "serves"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeCreatePayload",
    "kind": "LinkedField",
    "name": "recipeCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "picture",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createMutation",
    "operationKind": "mutation",
    "text": "mutation createMutation(\n  $name: String!\n  $category: ID\n  $difficulty: DifficultyEnum\n  $serves: String\n  $hotKeep: Boolean\n  $description: String\n) {\n  recipeCreate(input: {name: $name, category: $category, difficulty: $difficulty, serves: $serves, hotKeep: $hotKeep, description: $description}) {\n    recipe {\n      id\n      name\n      picture\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b7f28ad2779302e6ca01ca833eff336';

module.exports = node;
